import React, { useState, useEffect } from 'react'
import c from 'classnames'
import get from 'lodash/get'
import { connect } from 'react-redux'

import Modal, { ModalBody } from 'discada/dist/Modal'

import Ring from './Ring'
import Vertical from './VerticalProgress'

import { getProgramCount } from 'selectors/quoteSelectors'
import { ReactionSection } from 'components/widgets/Reactions/ReactionSection'

import { isOnVDP, getCustomerVerifications } from 'selectors/appStatusSelectors'
import { num } from 'utils'
import { getFilteredInventoryCount } from 'selectors/inventorySelectors'

import './index.scss'

export const PROGRESS_MAX = 100,
  CLASS_NAME = 'frikin-distractor',
  DURATION = 2 * 1000,
  FINISH_DURATION = 1500,
  COMPLETE_STOP = 'Your Payments are Ready!',
  COMPLETE_ICON = 'flag-checkered',
  VDP_STOPS = ({ trades, location } = {}) => {
    return [
      {
        key: 'banks',
        name: 'Talking to Banks',
        icon: 'university',
        weight: 2,
      },
      location
        ? {
            key: 'taxes',
            name: 'Calculating Fees & Taxes',
            icon: 'map-marker-alt',
          }
        : null,
      { key: 'incentives', name: 'Looking for Incentives', icon: 'search' },
      trades
        ? { key: 'trade', name: 'Applying Your Trade', icon: 'car' }
        : null,
      { key: 'cash', name: 'Applying Your Cash', icon: 'money-bill-wave' },
      {
        key: 'verifying',
        name: 'Verifying Your Payments',
        icon: 'badge-check',
        weight: 2,
      },
    ].filter(x => x)
  },
  VLP_STOPS = ({ trades } = {}) => {
    return [
      {
        key: 'inventory',
        name: 'Checking Inventory',
        icon: 'warehouse',
      },
      trades
        ? { key: 'trade', name: 'Applying Your Trade', icon: 'car' }
        : null,
      { key: 'incentives', name: 'Looking for Incentives', icon: 'search' },
      { key: 'cash', name: 'Applying Your Cash', icon: 'money-bill-wave' },
      {
        key: 'verifying',
        name: 'Verifying Your Payments',
        icon: 'badge-check',
        weight: 2,
      },
    ].filter(x => x)
  },
  cn = (...args) => args.map(c => [CLASS_NAME, c].join('-'))

//---------------

export function Distractor(props) {
  let {
      duration = DURATION,
      stops = [],
      onComplete = () => {},
      finishOk = true,
      reactionMode,
    } = props,
    [currentStop, setCurrentStop] = useState(0),
    stopDuration = Math.ceil(duration / stops.length),
    progress = Math.ceil((currentStop / stops.length) * 100),
    { weight = 1 } = get(stops, currentStop, {})

  useEffect(() => {
    let wait = stopDuration + Math.random() * 1000 * weight,
      okToMove = currentStop < stops.length,
      okToFinish = !okToMove && finishOk,
      nextStop

    if (okToMove)
      nextStop = setTimeout(() => setCurrentStop(currentStop + 1), wait)

    if (okToFinish) nextStop = setTimeout(() => onComplete(), FINISH_DURATION)

    return () => clearTimeout(nextStop)
  }, [currentStop, finishOk, onComplete, stopDuration, stops.length, weight])

  return (
    <ReactionSection
      className={c(CLASS_NAME, { [cn('reaction')]: reactionMode })}
    >
      <div className={cn('content')}>
        <Ring {...props} progress={progress} stop={stops[currentStop]} />
      </div>
    </ReactionSection>
  )
}

export function DistractorModal(props) {
  return (
    <Modal className={c(cn('modal'), 'inverted')} noClose>
      <ModalBody>
        <ConnectedDistractor {...props} />
      </ModalBody>
    </Modal>
  )
}

//-------------------------------------

function mapStateToProps(state, op) {
  let onVDP = isOnVDP(state),
    programCount = getProgramCount(state),
    vehicleCount = getFilteredInventoryCount(state),
    verifications = getCustomerVerifications(state),
    stops = onVDP ? VDP_STOPS : VLP_STOPS,
    finishContent

  if (onVDP) {
    finishContent =
      programCount > 0 ? (
        <span>
          We found <strong>{num(programCount)} payment options</strong> for you!
        </span>
      ) : (
        'Your payments are ready!'
      )
  } else {
    finishContent =
      vehicleCount > 0 ? (
        <span>
          We found <strong>{num(vehicleCount)} vehicle options</strong> for you!
        </span>
      ) : (
        'Your results are ready!'
      )
  }

  return {
    ...op,
    finishContent,
    stops: stops(verifications),
  }
}

export const ConnectedDistractor = connect(mapStateToProps)(Distractor)
